import React from 'react'

const FieldError = ({ error }) => (error ? <small className="text-danger d-block mt-1">{error}</small> : null)

export default FieldError
